import { ContractorCitationStatus } from '../../enums/contractor-citation-status.enum';

export interface ContractorCitationDetailDto {
  id: string;
  facilityId: string;
  status: ContractorCitationStatus;
  reportedDate: string;
  facilityName: string;
  facilityAddress: string;
  reportedBy: string;
  reportedByPosition: string;
  title: string;
  issue: string;
  requiredStepOrTraining: string;
}

export interface ContractorCitationListDto {
  id: string;
  title: string;
  createdAt: string;
  facilityName: string;
  status: ContractorCitationStatus;
}

export interface CreateContractorCitationDto {
  facilityId: string;
  contractorId: string;
  title: string;
  issue: string;
  requiredStepOrTraining: string;
}

export interface UpdateContractorCitationDto {
  title: string;
  issue: string;
  requiredStepOrTraining: string;
}
